module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cbb4A"))).then(() => module.bundle.root('7CAUa'));